import { pushRetryableEvent } from "./utils";

export default MessageSwipeManager = {
    mounted() {
        function convertRemToPixels(rem) {
            return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
        }

        this.el.addEventListener("touchend", (event) => {
            let container;
            if (event.target.matches(".tb-scroll-container")) {
                container = event.target;
            } else {
                container = event.target.closest(".tb-scroll-container");
            }

            const minDistance = convertRemToPixels(5);

            if (container.scrollLeft == 0) {
                pushRetryableEvent(this, "trigger_clear_read", container.id);
            } else if (container.scrollLeft > 2 * minDistance + 15) {
                pushRetryableEvent(this, "trigger_delete_confirmation", container.id);
            } else {
                console.log(`did not swipe enough, ${container.scrollLeft}`);
            }
        });
    },
};
